import { SyncOutlined } from '@ant-design/icons'
import { useQueryClient } from '@tanstack/react-query'
import { Modal, Radio, Space } from 'antd'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import 'react-quill/dist/quill.snow.css'
import { useParams } from 'react-router-dom'
import axiosClient from 'services/axios-client'
import { ROLES } from 'services/constants'

function RoleEditModal({ open, onClose, roleOptions, friend }) {
  const { t } = useTranslation()
  const { lang } = useContext(DataContext)
  const queryClient = useQueryClient()
  const { bookId } = useParams()

  const [newRole, setNewRole] = useState(null)
  const [isUpdating, setIsUpdating] = useState(false)

  useEffect(() => {
    if (friend?.name) {
      const currentRole = Object.values(roleOptions).find(
        (ro) => ro.label_en === friend.name,
      ).id
      setNewRole(currentRole)
    }
  }, [friend, roleOptions])

  const updateRole = async () => {
    setIsUpdating(true)
    const role_id = friend.role_id
    const role_type_id = ROLES[newRole].value

    const { ok } = await axiosClient.put(`/role/${role_id}`, { role_type_id })

    if (ok) {
      queryClient.invalidateQueries({ queryKey: ['book', bookId, 'users'] })
      setIsUpdating(false)
      onClose()
    }
  }

  return (
    <Modal
      title={t('change_role')}
      open={open}
      onCancel={onClose}
      closable={true}
      maskClosable={false}
      footer={false}
      centered={true}
      width={320}
      wrapClassName="modal-roles-wrapper"
      getContainer={() => document.getElementById('friends-section')}
    >
      <div className="modal-roles modal-custom-body">
        <h4>
          {friend?.first_name} {friend?.last_name}
        </h4>
        <Radio.Group
          onChange={(e) => setNewRole(e.target.value)}
          value={newRole}
        >
          <Space direction="vertical" size={16}>
            {Object.values(roleOptions).map((role) => (
              <Radio key={role.id} value={role.id}>
                {role[`label_${lang}`]}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        <div className="description">
          <span>
            {newRole ? roleOptions[newRole][`description_${lang}`] : ''}
          </span>
        </div>
      </div>

      <div className="modal-roles modal-custom-footer">
        <div className="actions">
          <Button className="btn-white btn-dash" onClick={() => onClose()}>
            {t('cancel')}
          </Button>
          <Button className="btn-blue btn-dash" onClick={updateRole}>
            {t('save')}
          </Button>

          {isUpdating && <SyncOutlined spin />}
        </div>
      </div>
    </Modal>
  )
}

export default RoleEditModal
